import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ApprenticeForm } from "../../../components/apprentice/ApprenticeForm";
import { getFullName } from "../../../helpers/stringHelper";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Apprentice } from "../../../models/apprentice";
import type { ApprenticeSupervisor } from "../../../models/apprenticeSupervisor";
import type { Company } from "../../../models/company";
import type { Group } from "../../../models/group";
import type { School } from "../../../models/school";
import type { YearContext } from "../../../models/yearContext";
import { apprentice_path, apprentices_path } from "../../../routes";

type ApprenticeEditProps = {
  apprentice: Apprentice;
  companies: Company[];
  apprentice_supervisors: ApprenticeSupervisor[];
  year_contexts: YearContext[];
  groups: Group[];
  schools: School[];
};

export default function ApprenticeEdit({
  apprentice,
  companies,
  apprentice_supervisors,
  year_contexts,
  groups,
  schools,
}: ApprenticeEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(apprentice_path, apprentice.id), values);

  return (
    <ContentShell title={`Lerndende/r ${getFullName(apprentice)}`} onBack={() => router.get(pathWithYearContext(apprentices_path))}>
      <ApprenticeForm
        schools={schools}
        apprentice={apprentice}
        yearContexts={year_contexts}
        companies={companies}
        apprentice_supervisors={apprentice_supervisors}
        submitButtonLabel="Speichern"
        onSubmit={onSubmit}
        groups={groups}
      />
    </ContentShell>
  );
}
